export const SCREENING_STATUS = {
  NOT_ASKED: "NOT_ASKED",
  LOADING: "LOADING",
  LOAD_SUCCESS: "LOAD_SUCCESS",
  LOAD_ERROR: "LOAD_ERROR"
};

export const SCREENING_QUERY_PARAMS = {
  NAME: "name",
  BIRTH_DATE: "birthDate",
  THRESHOLD: "threshold"
};

export const THRESHOLD_VALUE = 85;
